var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsNoEmployees(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "122px",
    viewBox: "0 0 114 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manager-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Campaign-Details/-EmptyState-/-NoItems",
    transform: "translate(-923.000000, -327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(923.000000, 327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0121456,25.3475277 C38.3503778,11.3880883 46.5763535,-0.71823548 62.0573239,0.0332180631 C70.0720801,-0.143562255 71.7003495,12.1515893 66.9421321,36.9186726 C63.97454,44.8787127 65.6869659,54.195185 72.0794097,64.8680895 C81.6680754,80.8774464 89.1141121,100.229172 70.6378355,117.383618 C51.705749,127.648293 38.4523981,120.79509 30.8777828,96.82401 C26.4273432,72.9413367 27.1387975,49.1158426 33.0121456,25.3475277 Z",
    id: "Path-5",
    fill: "#00FFA6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3AACE2",
    cx: 25,
    cy: 21.5,
    rx: 19,
    ry: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.147262184,91.1570596 C-0.964690632,81.1787692 4.22048779,76.1896241 15.7027974,76.1896241 C32.9262619,76.1896241 52.3996012,72.519415 57.0882176,66.8029279 C58.6353508,63.6726042 58.6353508,60.6351837 57.0882176,57.6906664 C57.6988866,51.6449329 63.248027,49.6964251 73.7356386,51.8451429 C89.4670559,55.0682196 123.631865,61.8072155 111.412188,88.7291382 C107.468809,97.8498636 94.9099587,102.606818 73.7356386,103 C39.282414,103 18.7164021,103 12.0376027,103 C5.35880325,103 1.39535643,99.0523532 0.147262184,91.1570596 Z",
    id: "Path-6",
    fill: "#3AACE2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "40-Online-Marketing",
    transform: "translate(24.328767, 29.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6458333,12.1875 L63.6458333,58.2291667 C63.6458333,61.2207091 61.2207091,63.6458333 58.2291667,63.6458333 L6.77083333,63.6458333 C3.77929094,63.6458333 1.35416667,61.2207091 1.35416667,58.2291667 L1.35416667,12.1875 L63.6458333,12.1875 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6458333,6.77083333 L63.6458333,12.1875 L1.35416667,12.1875 L1.35416667,6.77083333 C1.35416667,3.77929094 3.77929094,1.35416667 6.77083333,1.35416667 L58.2291667,1.35416667 C61.2207091,1.35416667 63.6458333,3.77929094 63.6458333,6.77083333 Z",
    id: "Path",
    fill: "#3AACE2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBF6FC",
    cx: 48.75,
    cy: 36.5625,
    r: 14.8958333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4583333,59.5833333 L51.4583333,63.6458333 L46.0416667,63.6458333 L46.0416667,59.5833333 C46.0527264,58.0921673 47.2588339,56.8860598 48.75,56.875 C50.2439192,56.8794617 51.4538716,58.0894141 51.4583333,59.5833333 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75,20.3125 C40.09208,20.3850851 33.0115901,27.2333083 32.6503772,35.8839945 C32.2891644,44.5346807 38.7741023,51.9493338 47.3958333,52.7434375 L47.3958333,55.7659375 C46.8302436,55.9578346 46.3170363,56.2786471 45.8967708,56.7030208 C45.1177153,57.4580136 44.680884,58.4984841 44.6875,59.5833333 L44.6875,63.6458333 C44.6875,64.3937189 45.2937811,65 46.0416667,65 L51.4583333,65 C52.2062189,65 52.8125,64.3937189 52.8125,63.6458333 L52.8125,59.5833333 C52.8053887,57.8678947 51.7215168,56.341803 50.1041667,55.77 L50.1041667,52.7434375 C58.7258977,51.9493338 65.2108356,44.5346807 64.8496228,35.8839945 C64.4884099,27.2333083 57.40792,20.3850851 48.75,20.3125 Z M50.1041667,62.2916667 L47.3958308,62.2916667 L47.3958308,59.5833333 C47.3951143,59.2178892 47.5455854,58.8684239 47.8115625,58.6178125 C48.0586381,58.3662305 48.3973963,58.2259367 48.75,58.2291667 C49.4978856,58.2291667 50.1041667,58.8354477 50.1041667,59.5833333 L50.1041667,62.2916667 Z M48.75,50.1041667 C41.271144,50.1041667 35.2083333,44.041356 35.2083333,36.5625 C35.2083333,29.083644 41.271144,23.0208333 48.75,23.0208333 C56.228856,23.0208333 62.2916667,29.083644 62.2916667,36.5625 C62.2834572,44.0379529 56.2254529,50.0959572 48.75,50.1041667 L48.75,50.1041667 Z",
    id: "Shape",
    fill: "#21445E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2291667,0 L6.77083333,0 C3.03326136,0.00447703254 0.00447703254,3.03326136 0,6.77083333 L0,58.2291667 C0.00447703254,61.9667386 3.03326136,64.995523 6.77083333,65 L37.9166667,65 L37.9166667,62.2916667 L6.77083333,62.2916667 C4.52717654,62.2916667 2.70833333,60.4728235 2.70833333,58.2291667 L2.70833333,6.77083333 C2.70833333,4.52717654 4.52717654,2.70833333 6.77083333,2.70833333 L58.2291667,2.70833333 C60.4728235,2.70833333 62.2916667,4.52717654 62.2916667,6.77083333 L62.2916667,18.9583333 L65,18.9583333 L65,6.77083333 C64.995523,3.03326136 61.9667386,0.00447703254 58.2291667,0 Z",
    id: "Path",
    fill: "#21445E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#21445E",
    x: 5.41666667,
    y: 10.8333333,
    width: 54.1666667,
    height: 2.70833333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#21445E",
    x: 6.77083333,
    y: 5.41666667,
    width: 2.70833333,
    height: 2.70833333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#21445E",
    x: 12.1875,
    y: 5.41666667,
    width: 2.70833333,
    height: 2.70833333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#21445E",
    x: 55.5208333,
    y: 5.41666667,
    width: 2.70833333,
    height: 2.70833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2708333,36.5625 L41.9791667,36.5625 C41.9836437,32.824928 45.012428,29.7961437 48.75,29.7916667 L48.75,27.0833333 C43.5175845,27.0900478 39.2775478,31.3300845 39.2708333,36.5625 L39.2708333,36.5625 Z",
    id: "Path",
    fill: "#21445E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(34.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#21445E",
    strokeWidth: 2,
    fill: "#EBF6FC",
    cx: 8.5,
    cy: 4.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#21445E",
    strokeWidth: 2,
    fill: "#EBF6FC",
    cx: 8.5,
    cy: 14.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 13,
    width: 17,
    height: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(34.000000, 66.918367)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#21445E",
    strokeWidth: 2,
    fill: "#EBF6FC",
    cx: 8.5,
    cy: 4.58163265,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#21445E",
    strokeWidth: 2,
    fill: "#EBF6FC",
    cx: 8.5,
    cy: 14.5816327,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 13.0816327,
    width: 17,
    height: 10
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsNoEmployees);
export default __webpack_public_path__ + "static/media/ES_NoEmployees.d4f127bc7bed0a216605ecd736d4b126.svg";
export { ForwardRef as ReactComponent };